import { selectDispatchRibbonData } from "./resultsChromeData.js";
import { buildPlanningOptimizeConfirmationContent, buildResultsState } from "./resultsWorkspaceData.js";

// The shortcut must use the same data and guards as the full evening workspace.
export function buildEveningOptimizationTarget({ dispatchDate = "", railState = null, includeSuspendedDeliveries = false, eveningOrderPool = null } = {}) {
  const unavailable = (disabledReason) => ({ disabledReason, model: null, allowEveningOrderPool: false });
  if (railState?.isLoading) return unavailable("Chargement du dispatch Soir en cours.");
  if (railState?.errorMessage) return unavailable(railState.errorMessage);
  const payload = railState?.payload;
  if (!dispatchDate || payload?.dispatch_date !== dispatchDate || !["evening", "soir"].includes(payload?.ui_dispatch_period || payload?.dispatch_period)) {
    return unavailable("Le dispatch Soir de cette date n’est pas encore disponible.");
  }
  const state = buildResultsState(payload);
  const model = selectDispatchRibbonData(state, {
    buildPlanningOptimizeConfirmationContent,
    includeSuspendedDeliveriesInOptimization: includeSuspendedDeliveries,
  });
  const controls = model.dispatchDayControls;
  const isClosed = controls?.activeItem?.isClosed === true
    || ["cloture", "closed"].includes(controls?.activeDispatchStatus)
    || (controls?.activeDispatchState || state.planningSummary?.dispatch_day_state) === "closed";
  return {
    model,
    allowEveningOrderPool: eveningOrderPool?.dispatchDate === dispatchDate
      ? eveningOrderPool.enabled === true : payload.evening_include_unassigned_day_orders === true,
    settingsDisabledReason: isClosed || ["frozen", "livre", "delivered"].includes(controls?.activeDispatchStatus)
      ? "Le statut du dispatch Soir ne permet pas de modifier cette option." : "",
    disabledReason: isClosed
      ? "Dispatch Soir clôturé : rouvrez-le avant d’optimiser."
      : eveningOrderPool?.disabledReason || "",
  };
}

const DAY_LABEL_FORMATTER = new Intl.DateTimeFormat("fr-CA", { day: "numeric", month: "long", timeZone: "UTC" });

export function buildScopedOptimizationConfirmation(confirmation, dispatchDate, dispatchPeriod) {
  const periodLabel = dispatchPeriod === "evening" ? "Soir" : "Jour";
  const dayLabel = /^\d{4}-\d{2}-\d{2}$/.test(String(dispatchDate)) ? DAY_LABEL_FORMATTER.format(new Date(dispatchDate)) : dispatchDate;
  return {
    ...confirmation,
    title: `Optimiser le ${periodLabel} — ${dayLabel} ?`,
    confirmLabel: `Optimiser le ${periodLabel.toLowerCase()}`,
  };
}
